<span>
  <div style="position: fixed">
    <mat-spinner [diameter]="40" style="margin-top: -10px"></mat-spinner>
  </div>
  <div style="font-size:12px; padding-left: 54px;">
    <mat-dialog-content>{{mensagem}}</mat-dialog-content>
  </div>
</span>
